module.exports = __webpack_public_path__ + "static/cateau0-6b4641b756e19f1d6d1ce8c81b2a1ad5.png";